const environments = {
    default: {
        depType: 'development',
        esspRootUrl: '',
        esspApi: 'v1',
        dummyApi: '',
        docPath: 'http:/localhost:90/v1/',
        esspSocket: 'wss://api.essp.com',
        enableSSO: true,
        redirectUrl: 'https://localhost:3000/login',
        adClientId: "3a0ed110-9c38-4442-99f6-131421317ecf",
        adTenantId: "67da140c-2b2e-4193-8cdf-3c07fc72ad37",
        serviceAccount: "ess-admin@espire.com"
    },

    development: {
        depType: 'development',
        esspRootUrl: 'http://localhost:90',
        esspApi: '/v1',
        dummyApi: '',
        docPath: 'http://localhost:90/v1/',
        esspSocket: 'wss://api.essp.com',
        enableSSO: false,
        redirectUrl: 'https://localhost:3000/login',
        adClientId: "3a0ed110-9c38-4442-99f6-131421317ecf",
        adTenantId: "67da140c-2b2e-4193-8cdf-3c07fc72ad37",
        serviceAccount: "ess-admin@espire.com"
    },

    sit: {
        depType: 'SIT',
        esspRootUrl: 'http://localhost:90',
        esspApi: '/v1',
        dummyApi: '',
        docPath: 'http://localhost:90/v1/',
        esspSocket: 'wss://api.essp.com',
        enableSSO: false,
        redirectUrl: 'http://172.16.5.89:81/login',
        adClientId: "3a0ed110-9c38-4442-99f6-131421317ecf",
        adTenantId: "67da140c-2b2e-4193-8cdf-3c07fc72ad37",
        serviceAccount: "ess-admin@espire.com"
    },
    production1: {
        depType: 'development',
        esspRootUrl: 'http://172.16.5.90:90',
        esspApi: '/v1',
        dummyApi: '',
        docPath: 'http://172.16.5.90:90/v1/',
        esspSocket: 'wss://api.essp.com',
        enableSSO: false,
        redirectUrl: 'http://172.16.5.89:85/login',
        adClientId: "3a0ed110-9c38-4442-99f6-131421317ecf",
        adTenantId: "67da140c-2b2e-4193-8cdf-3c07fc72ad37",
        serviceAccount: "ess-admin@espire.com"
    },
    stage: {
        depType: 'STAGE',
        esspRootUrl: 'http://172.16.5.90:90',
        esspApi: '/v1',
        dummyApi: '',
        docPath: 'http://172.16.5.90:90/v1/',
        esspSocket: 'wss://api.essp.com',
        serviceAccount: "ess-admin@espire.com"
    },
    production: {
        depType: 'production',
        esspRootUrl: 'https://apis-ess.espire.com/',
        esspApi: 'v1',
        dummyApi: '',
        docPath: 'https://apis-ess.espire.com/v1/',
        esspSocket: 'wss://api.essp.com',
        enableSSO: true,
        redirectUrl: 'https://ess.espire.com/login',
        adClientId: "9e1f7196-1b2c-4e61-bf98-e9ccee46350c",
        adTenantId: "67da140c-2b2e-4193-8cdf-3c07fc72ad37",
        serviceAccount: "ess-admin@espire.com"
    }
}
const properties = {
    depType: environments[process.env.NODE_ENV],
    esspRootUrl: 'report',
    esspTokenApi: 'token',
    currentEnvironment: environments[process.env.NODE_ENV] ? environments[process.env.NODE_ENV] : environments['default'],
    environments: environments
}
export default properties
